import { Box } from '@chakra-ui/react';

const NoBorderBox = ({ children }) => {
  return (
    <Box
      width="100%"
      height="100%"
      padding="16px"
      margin="0"
    >
      {children}
    </Box>
  );
};

export default NoBorderBox;
